(function() { window.GUID_abacd25d_d97a_4f7b_8ff4_9cbdad4b2e9f = { getGuid: function() { return "abacd25d-d97a-4f7b-8ff4-9cbdad4b2e9f"; } }; })();
var CS;
(function (CS) {
    var Entity;
    (function (Entity) {
        var General;
        (function (General) {
            let ImageHistoryTypeEnum;
            (function (ImageHistoryTypeEnum) {
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Person"] = 0] = "Person";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["HomePage"] = 1] = "HomePage";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["ImageDynamicDisplay"] = 2] = "ImageDynamicDisplay";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Place"] = 3] = "Place";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Publicity"] = 4] = "Publicity";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["SportEvent"] = 5] = "SportEvent";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["Team"] = 6] = "Team";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["ProfilPicture"] = 7] = "ProfilPicture";
                ImageHistoryTypeEnum[ImageHistoryTypeEnum["FacebookShare"] = 8] = "FacebookShare";
            })(ImageHistoryTypeEnum = General.ImageHistoryTypeEnum || (General.ImageHistoryTypeEnum = {}));
        })(General = Entity.General || (Entity.General = {}));
    })(Entity = CS.Entity || (CS.Entity = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ImageHistoryTypeEnum.pre.js.map
